var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _path0, _g3, _path1, _g4, _path10, _path11, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutsideBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 58,
    viewBox: "0 0 44 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_814_15)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8812 23.2062V24.5385C18.8812 24.7011 18.9511 24.8522 19.0637 24.9684L20.8038 26.6996C20.9165 26.8158 21.0719 26.8816 21.235 26.8816H22.6721C22.8353 26.8816 22.9906 26.8158 23.1033 26.6996L24.8434 24.9684C24.956 24.8522 25.026 24.7011 25.026 24.5385V23.2062H18.8812ZM22.6721 28.1054H21.235C20.7533 28.1054 20.2756 27.904 19.93 27.5709L18.1937 25.8398C17.8558 25.4951 17.6538 25.0149 17.6538 24.5385V22.5943C17.6538 22.2613 17.9335 21.9824 18.2675 21.9824H25.6397C25.9737 21.9824 26.2533 22.2613 26.2533 22.5943V24.5385C26.2533 25.0149 26.0514 25.4951 25.7135 25.8398L23.9772 27.5709C23.6315 27.904 23.1538 28.1054 22.6721 28.1054Z",
    fill: "#13373F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6399 23.206C25.3019 23.206 25.0261 22.931 25.0261 22.5941V20.7584C25.0261 20.2588 25.1505 19.763 25.3874 19.3138L26.8284 16.6144C26.8479 16.5757 26.8673 16.5485 26.8945 16.5292C27.279 15.7236 27.481 14.8832 27.481 14.0235C27.481 10.9794 25.0067 8.51235 21.9538 8.51235C18.9008 8.51235 16.4266 10.9794 16.4266 14.0235C16.4266 14.8832 16.6285 15.7236 17.0131 16.5292C17.0403 16.5485 17.0597 16.5757 17.0791 16.6144L18.5202 19.3138C18.7571 19.763 18.8814 20.2588 18.8814 20.7584V22.5941C18.8814 22.931 18.6056 23.206 18.2677 23.206C17.9336 23.206 17.654 22.931 17.654 22.5941V20.7584C17.654 20.4601 17.5763 20.1542 17.4326 19.8986L16.0421 17.296C16.0226 17.2573 15.9955 17.2186 15.976 17.1876C15.4594 16.1922 15.1992 15.1233 15.1992 14.0235C15.1992 10.3094 18.2289 7.28467 21.9538 7.28467C25.6787 7.28467 28.7083 10.3094 28.7083 14.0235C28.7083 15.1233 28.4481 16.1922 27.9316 17.1876C27.9121 17.2263 27.8849 17.265 27.8538 17.3037L26.475 19.8986C26.3312 20.1542 26.2536 20.4601 26.2536 20.7584V22.5941C26.2536 22.931 25.9739 23.206 25.6399 23.206Z",
    fill: "#13373F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_814_15",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 0,
    width: 3,
    height: 4
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6323 0.0620117H22.621V3.96586H20.6323V0.0620117Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_814_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9526 3.61334C21.6185 3.61334 21.3389 3.33449 21.3389 3.00142V0.549901C21.3389 0.216834 21.6185 -0.0620117 21.9526 -0.0620117C22.2866 -0.0620117 22.5662 0.216834 22.5662 0.549901V3.00142C22.5662 3.33449 22.2866 3.61334 21.9526 3.61334Z",
    fill: "#13373F"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4626 15.8591H33.0077C32.6698 15.8591 32.394 15.5803 32.394 15.2472C32.394 14.9102 32.6698 14.6353 33.0077 14.6353H35.4626C35.8005 14.6353 36.0762 14.9102 36.0762 15.2472C36.0762 15.5803 35.8005 15.8591 35.4626 15.8591Z",
    fill: "#13373F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8991 15.8591H8.44425C8.10635 15.8591 7.83057 15.5803 7.83057 15.2472C7.83057 14.9102 8.10635 14.6353 8.44425 14.6353H10.8991C11.237 14.6353 11.5128 14.9102 11.5128 15.2472C11.5128 15.5803 11.237 15.8591 10.8991 15.8591Z",
    fill: "#13373F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9145 6.9247C30.7513 6.9247 30.5998 6.86661 30.4755 6.75043C30.2347 6.51031 30.2347 6.11915 30.4755 5.87903L32.2118 4.14786C32.4526 3.90774 32.8449 3.90774 33.0857 4.14786C33.3226 4.38798 33.3226 4.77913 33.0857 5.01925L31.3495 6.75043C31.2213 6.86661 31.0698 6.9247 30.9145 6.9247Z",
    fill: "#13373F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.992 6.9247C12.8366 6.9247 12.6852 6.86661 12.557 6.75043L10.8208 5.01925C10.5838 4.77913 10.5838 4.38798 10.8208 4.14786C11.0616 3.90774 11.4538 3.90774 11.6946 4.14786L13.4309 5.87903C13.6717 6.11915 13.6717 6.51031 13.4309 6.75043C13.3066 6.86661 13.1551 6.9247 12.992 6.9247Z",
    fill: "#13373F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_814_15",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 28,
    width: 24,
    height: 16
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6323 28.752H43.4402V43.6237H20.6323V28.752Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_814_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.009 37.4817L26.998 41.4515L41.7773 34.6507L37.7844 30.681L23.009 37.4817ZM26.8659 42.8031C26.7028 42.8031 26.5475 42.7449 26.4348 42.6211L21.5214 37.7218C21.3777 37.5786 21.3077 37.3772 21.3466 37.1874C21.3854 36.9861 21.5097 36.8234 21.6922 36.7343L37.6601 29.3875C37.8893 29.2752 38.1689 29.3294 38.3515 29.5114L43.265 34.4106C43.4087 34.5539 43.4747 34.7553 43.4359 34.9451C43.397 35.1464 43.2727 35.309 43.0902 35.3981L27.1262 42.7449C27.0369 42.7837 26.9514 42.8031 26.8659 42.8031Z",
    fill: "#13373F"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.922 30.5571C37.8366 30.5571 37.7473 30.5377 37.6618 30.499L30.2935 27.1219C29.9866 26.9786 29.8507 26.6145 29.9944 26.3085C30.1381 26.0026 30.5032 25.8671 30.8101 26.0103L38.1784 29.3875C38.4892 29.5308 38.6212 29.8949 38.4774 30.2008C38.3726 30.4215 38.1512 30.5571 37.922 30.5571Z",
    fill: "#13373F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_814_15",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 35,
    width: 20,
    height: 23
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6323 35.6924H39.525V57.3184H20.6323V35.6924Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_814_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9524 57.4966C21.7232 57.4966 21.5018 57.3649 21.397 57.1441C21.2533 56.8382 21.3853 56.4742 21.6921 56.3308L37.3065 49.1467V37.0904C37.3065 36.7535 37.5823 36.4785 37.9202 36.4785C38.2543 36.4785 38.534 36.7535 38.534 37.0904V49.5378C38.534 49.7779 38.398 49.9948 38.1766 50.0916L22.2126 57.4385C22.1233 57.4772 22.0379 57.4966 21.9524 57.4966Z",
    fill: "#13373F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_814_15",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 28,
    width: 23,
    height: 16
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0.186523 28.752H22.6215V43.6237H0.186523V28.752Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_814_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.1285 34.6507L16.9078 41.4515L20.8969 37.4817L6.12144 30.681L2.1285 34.6507ZM17.0399 42.8031C16.9544 42.8031 16.8689 42.7837 16.7796 42.7449L0.815642 35.3981C0.633089 35.309 0.508795 35.1464 0.469953 34.9451C0.431111 34.7553 0.497143 34.5539 0.640857 34.4106L5.55435 29.5114C5.7369 29.3294 6.01656 29.2752 6.24573 29.3875L22.2136 36.7343C22.3962 36.8234 22.5205 36.9861 22.5593 37.1874C22.5981 37.3772 22.5282 37.5786 22.3845 37.7218L17.471 42.6211C17.3584 42.7449 17.203 42.8031 17.0399 42.8031Z",
    fill: "#13373F"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98504 30.5571C5.75587 30.5571 5.53448 30.4215 5.4296 30.2008C5.28588 29.8949 5.41795 29.5308 5.72868 29.3875L13.097 26.0103C13.4038 25.8671 13.7689 26.0026 13.9126 26.3085C14.0563 26.6145 13.9204 26.9786 13.6136 27.1219L6.24528 30.499C6.15983 30.5377 6.07049 30.5571 5.98504 30.5571Z",
    fill: "#13373F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_814_15",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 35,
    width: 19,
    height: 23
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72363 35.6924H22.622V57.3184H4.72363V35.6924Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_814_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9532 57.4966C21.8677 57.4966 21.7822 57.4772 21.6929 57.4385L5.72893 50.0916C5.50753 49.9948 5.37158 49.7779 5.37158 49.5378V37.0904C5.37158 36.7535 5.65125 36.4785 5.98528 36.4785C6.32321 36.4785 6.59899 36.7535 6.59899 37.0904V49.1467L21.3395 55.9281V37.2919C21.3395 36.9549 21.6191 36.68 21.9532 36.68C22.2872 36.68 22.5668 36.9549 22.5668 37.2919V56.8846C22.5668 57.0938 22.462 57.2874 22.2872 57.4037C22.1823 57.4695 22.0697 57.4966 21.9532 57.4966Z",
    fill: "#13373F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_814_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsideBox);
export default __webpack_public_path__ + "static/media/OutsideBox.35fbd07ed49312f0f71758edf52959d3.svg";
export { ForwardRef as ReactComponent };